import moment from 'moment';
import { ConstantUtil } from '@/utils/ConstantUtil';
import Utils from './Utils';
import Config from './Config';

let HOST;
let HOST_V2;
let SERVER_PREFIX;
let SERVER_PREFIX_V2;
let config; // http 接口地址前缀
let pixiu;
let HOST_API;
const LanguageArray = ConstantUtil.LanguageArray;
const HostArray = ConstantUtil.HostArray;
const Markets = Config.Markets;
const GoogleAnalyticsKey = Config.GoogleAnalyticsKey;
const WebsiteName = Config.WebsiteName;
const WebsiteIcon = Config.WebsiteIcon;
const WebsiteLogo = Config.WebsiteLogo;
const FAQURL = Config.FAQURL;
const SupportEmail = Config.SupportEmail;
const Copyright = Config.Copyright;

if (process.env.NODE_RUN_ENV === 'TEST') {
    HOST = Utils.getHostByCode(Utils.getQueryObject().host || localStorage.getItem('host')).host;
    if (Config.isPartner) {
        HOST = Config.TestHost;
    }
    // HOST = 'https://p2.bytetrade.io';
    HOST_V2 = 'https://api-v2-test.bytetrade.com';
    pixiu = 'https://newton.bytetrade.io/pixiu/api/v1';
    // pixiu = 'https://pixiu.bytetrade.io/api/v1';
    HOST_API = 'https://api_test.bytetrade.com/bittrade/v2/me';
} else { // 线上环境
    HOST = Utils.getHostByCode(Utils.getQueryObject().host || localStorage.getItem('host')).host;
    if (Config.isPartner) {
        HOST = Config.PrdHost;
    }
    HOST_V2 = 'https://api-v2.bytetrade.com';
    pixiu = 'https://pixiu.bytetrade.io/api/v1';
    HOST_API = 'https://api.bytetrade.com/bittrade/v2/me';
}
if (Config.ProjectName === 'bittrade') {
    SERVER_PREFIX = `${HOST}/${Config.ProjectName}/v1`;
    SERVER_PREFIX_V2 = `${HOST}/${Config.ProjectName}/v2/me`;
} else {
    SERVER_PREFIX = `${HOST}/${Config.ProjectName}/api/v1`;
    SERVER_PREFIX_V2 = `${HOST}/${Config.ProjectName}/v2/me`;
}

const cmd = {
    marketList: 'markets',
    aseetList: 'currencies',
    tradeInit: 'init',
    currencies: 'currencies',
    markets: 'markets',
    marketsPrice: 'marketsPrice',
    dealsData: 'dealsData',
    depthData: 'depthData',
    listAccounts: 'listAccounts',
    klineData: 'klineData',
    deposit: 'deposit',
    listDeposits: 'listDeposits',
    withdraw: 'withdraw',
    listWithdraws: 'listWithdraws',
    listTransfer: 'listTransfer',
    newOrder: 'newOrder',
    cancelOrder: 'cancelOrder',
    orderStatus: 'orderStatus',
    openOrders: 'openOrders',
    finishedOrders: 'finishedOrders',
    userDeals: 'userDeals',
    tradeFees: 'tradeFees',
    register: 'isUserIDRegister',
    users: 'users',
    depositAddress: 'requestAddress',
    putTransaction: 'putTransaction',
};
// test
const timezone = ConstantUtil.TimetoneMap[Utils.getHostByCode(Utils.getQueryObject().host || localStorage.getItem('host')).code] || 'Asia/Tokyo'; // 默认时区 - 东京
const dapp = Config.dappid;

function time(value, f) {
    let format = f;
    if (!format) format = 'HH:mm:ss';
    return moment.unix(value).format(format);
}


const webSocketAddress = Utils.getHostByCode(Utils.getQueryObject().host || localStorage.getItem('host')).ws;


// eslint-disable-next-line consistent-return


function getAsset(a) {
    const asset = a;
    let assetObj = null;
    let assets = localStorage.getItem('assets');
    if (assets) {
        assets = JSON.parse(assets);
        for (let i = 0; i < assets.length; i += 1) {
            if (asset == assets[i].code) {
                assetObj = assets[i];
                break;
            }
        }
    }
    return assetObj;
}

function getAssetDecimals(a) {
    let asset = a;
    asset = getAsset(asset);
    if (asset) return parseInt((Math.log(asset.basePrecision) / Math.log(10)).toFixed(0), 10);
    return 0;
}

function getBasePrecision(asset) {
    return getAsset(asset).basePrecision;
}

function getBasePrec(a) {
    let asset = a;
    asset = getAsset(asset);
    if (asset) return asset.basePrecision;
    return 0;
}

function getBlockDecimals(a) {
    let asset = a;
    asset = getAsset(asset);
    if (asset) return parseInt((Math.log(asset.externalPrecision) / Math.log(10)).toFixed(0), 10);
    return 0;
}

function getBlockPrec(a) {
    let asset = a;
    asset = getAsset(asset);
    if (asset) return asset.externalPrecision;
    return 0;
}


export default {
    HOST,
    config,
    HOST_V2,
    LanguageArray,
    HostArray,
    HOST_API,
    Markets,
    GoogleAnalyticsKey,
    WebsiteName,
    WebsiteIcon,
    WebsiteLogo,
    FAQURL,
    SupportEmail,
    Copyright,
    SERVER_PREFIX,
    SERVER_PREFIX_V2,
    cmd,
    dapp,
    webSocketAddress,
    timezone,
    time,
    getAsset,
    getAssetDecimals,
    getBasePrecision,
    getBasePrec,
    getBlockDecimals,
    getBlockPrec,
    pixiu,
};



// WEBPACK FOOTER //
// ./src/utils/settings.js